import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Router from 'ruta3';
import queryString from 'query-string';

import './App.css';

import Welcome from './views/Welcome';
import AccountActivate from './views/AccountActivate';
import Reset from './views/Reset';
import Registration from './views/Registration';
import NotFound from './views/NotFound';
import AppDownloadRedirect from './views/AppDownloadRedirect';

const routes = [
  {
    route: '/account/activate',
    getComponent: () => AccountActivate,
    layout: true
  },
  {
    route: '/reset/:token/:uuid/',
    getComponent: () => Reset,
    layout: true
  },
  {
    route: '/invitation/:uuid',
    getComponent: () => Registration
  },
  {
    route: '/',
    getComponent: () => Welcome
  },
  {
    route: '/code/:qr_version/:bike_uuid',
    getComponent: () => AppDownloadRedirect
  }
];



class App extends Component {
  constructor(props) {
    super(props);

    const {history} = props;

    this.state = {
      location: history.location
    };

    this.router = Router();
    routes.forEach(({route, getComponent}) => this.router.addRoute(
      route,
      getComponent
    ));

    history.listen(this.handleNavigation.bind(this));
  }

  getChildContext() {
    return {history: this.props.history}
  }

  handleNavigation(location) {
    this.setState({location});
  }

  render() {
    const {location: {pathname}} = this.state;
    const match = this.router.match(pathname)
    const params = match ? match.params : {};

    // 404
    const Component = match ? match.action() : NotFound;

    const query = queryString.parse(location.search);

    return <Component
      params={params}
      query={query}
    />
  }
}

App.childContextTypes = {
  history: PropTypes.object
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js